(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-specialty-template-wand"]) return;
  try {
    
$( ".product-specialty-details-section" ).ready(function() {
  $( ".drawer__header-container" ).css("background", "#FFEDEA");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specialty-template"]) return;
  try {
    
$( ".product-specialty-details-section" ).ready(function() {
  $( ".drawer__header-container" ).css("background", "#FFEDEA");
});

  } catch(e) { console.error(e); }
})();
})();
